// extracted by mini-css-extract-plugin
module.exports = {"main-component":"timerAlert_main-component__1GIli"};